import type { KeyboardEvent } from "react";

export default function CockpitTabs({ id, tabs, value, onChange }: {
  id: string; tabs: { id: string; label: string }[]; value: string; onChange: (value: string) => void;
}) {
  const keyDown = (event: KeyboardEvent<HTMLButtonElement>, index: number) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1
      : (index + (event.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length;
    onChange(tabs[next].id);
    document.getElementById(`${id}-${tabs[next].id}`)?.focus();
  };
  return <div className="subtabs" role="tablist" aria-label={`${id} 보기`}>
    {tabs.map((tab, index) => <button key={tab.id} id={`${id}-${tab.id}`} role="tab"
      className={`subtab ${value === tab.id ? "active" : ""}`} aria-selected={value === tab.id}
      aria-controls={`${id}-panel`} tabIndex={value === tab.id ? 0 : -1}
      onClick={() => onChange(tab.id)} onKeyDown={e => keyDown(e, index)}>{tab.label}</button>)}
  </div>;
}
